import store from '../../store'
import Vue from 'vue'
import {WS_URL} from '../../utils/config'

const loadAllList = (payload) => {
  return Vue.axios.post(`${WS_URL}cache`, payload, {withCredentials: true}).then(response => {
    store.dispatch(`loadTourList`, response.data.tours)
    store.dispatch(`loadServiceList`, response.data.servizi)
    return true
  })
}

export default {
  loadAllList
}



// WEBPACK FOOTER //
// ./src/front/actions/cache/index.js